import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { MdChevronRight } from "react-icons/md";
import {
  setCandidateData, setCandidateId
} from "../../redux/reducers/loginSlice";
import { useDispatch } from "react-redux";
import Loading from "../../images/loading.gif";
import { Loader } from "react-feather";
import { FiXCircle } from "react-icons/fi";
export default function CandidateLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  // localStorage?.setItem("isLogin", 1); //! Comment later
  const [siteDetails, setSiteDetails] = useState([]);

  useEffect(() => {
    getSiteDetails();
  }, []);


  const getSiteDetails = () => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    const webUrl = webUrlMatch ? webUrlMatch[1] : "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    backendApi(req).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        setSiteDetails(response.dataSet);
        if (response.dataSet.length > 0) {
          localStorage.setItem("logo", response.dataSet[0].company_logo);
        }
      } else {
        return false;
      }
    });
  };

  const Login = (e) => {
    // e.preventDefault();
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    } else if (password === "") {
      toast.warn("Please enter your password", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "candidate_login",
      email_id: userName,
      password: password,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          console.log("userdata", response);
          console.log(response.candidate_id, "response.candidate_id[0].id");
          dispatch(setCandidateData(response.candidateData));
          dispatch(setCandidateId(response.candidate_id));
          localStorage.setItem("candidateId", response.candidateData[0].id);
          window.location.href = "/dashboard/candidateDashboard";
        } else {
          toast.warn("Wrong username or password", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  const handleForgotPwd = () => {
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "resetCandidatePassword",
      email_id: userName,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success("Password sent to your Email Account", {
            containerId: "D",
          });
          setForgotPassword(false);
        } else {
          toast.warn("Something went wrong", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  return (
    <div className="bg-login">
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-xl-5 position-relative">
            <FiXCircle className="popup_close" onClick={() => navigate("/")} />
            <div className="card rounded-3 text-black">
              <div className="row">
                <div className="col-lg-12 m-auto">
                  <div className="card-body p-md-2 mx-md-4">
                    {siteDetails.length > 0 && (
                      <div className="text-center mb-0 recruitment_logo">
                        <img src={siteDetails[0].company_logo} width="250" />
                        {/* <span className="recruitment_text_logo">{siteDetails[0].company_name}</span> */}
                      </div>
                    )}
                    {forgotPassword ? (
                      <form>
                        <div className="form-outline mb-2">
                          <label className="form-label" for="form2Example11">
                            Email-Id
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email-Id"
                            value={userName}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        <div className="text-center pt-1 mb-2 pb-1 d-flex flex-column">
                          {dataFlag ? (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                              onClick={handleForgotPwd}
                            >
                              <img
                                src={Loading}
                                alt="loaderImg"
                                width={20}
                                height={20}
                              ></img>
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                              onClick={handleForgotPwd}
                            >
                              Submit
                            </button>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-4">
                          <p
                            className="mb-0 me-2 text-primary cursor-pointer"
                            onClick={() => setForgotPassword(false)}
                          >
                            Back to Login
                          </p>
                          <a
                            onClick={() => navigate("/candidateSignup")}
                            className="btn btn-outline-primary btn-sm create-new"
                          >
                            Signup
                          </a>
                        </div>
                      </form>
                    ) : (
                      <form>
                        <div className="form-outline mb-2">
                          <label className="form-label" for="form2Example11">
                            Email-Id
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email-Id"
                            value={userName}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>

                        <div
                          className="form-outline mb-2"
                          style={{ position: "relative", width: "100%" }}
                        >
                          <label className="form-label" for="form2Example22">
                            Password
                          </label>
                          <input
                            id="form2Example22"
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                Login(); // Call the Login method when the Enter key is pressed
                              }
                            }}
                          />
                          <span className="showPswd">
                            {showPassword && (
                              <FaEye onClick={() => setShowPassword(false)} />
                            )}
                            {!showPassword && (
                              <FaEyeSlash
                                onClick={() => setShowPassword(true)}
                              />
                            )}
                          </span>
                        </div>

                        <div className="text-center pt-1 mb-2 pb-1 d-flex flex-column">
                          {dataFlag ? (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                            >
                              <img
                                src={Loading}
                                alt="loaderImg"
                                width={20}
                                height={20}
                              ></img>
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3 mt-1"
                              type="button"
                              onClick={Login}
                            >
                              Log in
                            </button>
                          )}
                          <span
                            className="text-muted"
                            style={{ cursor: "pointer" }}
                            onClick={() => setForgotPassword(true)}
                          >
                            Forgot password?
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-4">
                          <p className="mb-0 me-2 sign-in-form">
                            Don't have an account?
                          </p>
                          <a
                            onClick={() => navigate("/candidateSignup")}
                            className="btn btn-outline-primary btn-sm create-new"
                          >
                            Signup
                          </a>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
